// extracted by mini-css-extract-plugin
export var alertIcon = "_n3-0";